import { C, BtnOrange, scrollTo, useIsMobile } from '../styles';

const services = [
  'Custom brackets & structural mounts',
  'Stainless steel shelving & food-grade fixtures',
  'CNC machined components & precision parts',
  'Small-batch prototype manufacturing',
  'Recurring production runs & volume orders',
  'Welded assemblies & structural fabrication',
];

export default function Services() {
  const isMobile = useIsMobile();
  return (
    <section id="services" style={{ padding: isMobile ? '64px 0' : '88px 0', borderTop: `1px solid ${C.bdr}`, background: '#ECF0F1' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: isMobile ? '0 16px' : '0 24px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: isMobile ? 28 : 52, alignItems: 'start' }}>
          <div>
            <span style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.2em', textTransform: 'uppercase', color: C.navy, display: 'block', marginBottom: 12 }}>What we build</span>
            <h2 style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 'clamp(28px, 5vw, 48px)', fontWeight: 700, lineHeight: 1.05, textTransform: 'uppercase', color: '#1A2530', marginBottom: 18 }}>Built for real manufacturing requirements</h2>
            <p style={{ color: '#5A7A8A', fontSize: 15, lineHeight: 1.75, marginBottom: 28 }}>
              Whether you're an inventor taking a product concept to its first prototype, or an operations manager who needs a reliable partner for recurring component orders — MetalMatch handles both with equal precision.
            </p>
            <BtnOrange onClick={() => scrollTo('submit')}>Get Quotes — Free</BtnOrange>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginTop: isMobile ? 4 : 0 }}>
            {services.map((s) => (
              <div key={s} style={{
                background: '#fff', border: '1px solid #C8D4DE',
                borderRadius: 8, padding: 18, transition: 'border-color 0.2s', cursor: 'default',
              }}
                onMouseEnter={e => e.currentTarget.style.borderColor = C.orange}
                onMouseLeave={e => e.currentTarget.style.borderColor = '#C8D4DE'}
              >
                <div style={{ width: 24, height: 2, background: C.orange, marginBottom: 10 }} />
                <div style={{ fontSize: 12, fontWeight: 600, color: '#1A2530', lineHeight: 1.5 }}>{s}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
